import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Client from './tools/client';

const ActionsAPI = new BaseAPI({
  url: `${process.env.MYPREDITY_BASE_URI}/actions`,
});

export function deleteDocument(id, body) {
  const url = `${process.env.MYPREDITY_BASE_URI}/actions/${id}/delete_document`;
  return Client.post(url, body).catch(errorHandler);
}

export default ActionsAPI;
